import React, { useMemo, useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Box,
  Card,
  Button,
  IconButton,
  FormControl,
  OutlinedInput,
  InputAdornment,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Autocomplete,
  TableBody,
} from "@mui/material";
import { useFormik } from "formik";
import { uploadImage } from "../../Components/UploadFile/upload";
import { useStyles } from "../../theme/appStyles";
import { useNotifier } from "../../Core/Notifier";
import {
  ICompanyDetails,
} from "../../Api/Interface/api.interface";
import {
  useCreateSettingMutation,
  useGetSettingQuery,
} from "../../Api/attoDeskApi";
import {
  formatPhoneNumberForDisplay,
  validatePhoneNumber,
} from "../../Components/Validation/validationUtils";
import { toProperCase } from "../../Components/Validation/toProperCase";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { FaTrash } from "react-icons/fa";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const toAllCaps = (text: string | null | undefined): string => {
  if (!text) return "";
  return text.toUpperCase();
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { showErrorMessage, showMessage } = useNotifier();
  const [selectedImage, setSelectedImage] = useState<File | undefined>(
    undefined
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [selectedImageUp, setSelectedImageUp] = useState<File | undefined>(
    undefined
  );
  const [isImageUploading2, setIsImageUploadingUp] = useState(false);

  const [selectedImagePunch, setSelectedImagePunch] = useState<
    File | undefined
  >(undefined);
  const [isImageUploadingPunch, setIsImageUploadingPunch] = useState(false);


  const { data, isLoading, isError } = useGetSettingQuery({
    searchText: "",
    id: "1",
  });

  const [settingData, { isLoading: settingLoading }] =
    useCreateSettingMutation();
  const [initialData, setInitialData] = useState<ICompanyDetails | null>(null);

  useEffect(() => {
    if (data?.data) {
      setInitialData(data.data as ICompanyDetails);
    }
  }, [data]);


  const handlePhoneChange = (
    fieldName: string,
    value: string,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const formattedValue = formatPhoneNumberForDisplay(value);
    setFieldValue(fieldName, formattedValue);
  };

  const formik = useFormik({
    initialValues: {
      companyName: initialData?.companyName || "",
      companyProvince: initialData?.companyProvince || "",
      companyCity: initialData?.companyCity || "",
      companyPostalCode: initialData?.companyPostalCode || "",
      companyStreetNumber: initialData?.companyStreetNumber || "",
      companyStreetName: initialData?.companyStreetName || "",
      companyPaymentMethod: initialData?.companyPaymentMethod || "",
      companyEmail: initialData?.companyEmail || "",

      companyMobileNumber: initialData?.companyMobileNumber
        ? formatPhoneNumberForDisplay(initialData.companyMobileNumber)
        : "",

      companyAltMobileNumber: initialData?.companyAltMobileNumber
        ? formatPhoneNumberForDisplay(initialData.companyAltMobileNumber)
        : "",
      companyWebSiteLink: initialData?.companyWebSiteLink || "",
      companyDescription: initialData?.companyDescription || "",
      companyLogo: initialData?.companyLogo || "",
      logowidthPrint: initialData?.logowidthPrint || "",
      backgroundImg: initialData?.backgroundImg || "",
      header_message: initialData?.header_message || "",
      body_message_start: initialData?.body_message_start || "",
      body_message_end: initialData?.body_message_end || "",
      footer_message: initialData?.footer_message || "",
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors: { [key: string]: string } = {};

      const companyMobileNumberError = validatePhoneNumber(
        values.companyMobileNumber
      );
      if (companyMobileNumberError) {
        errors.companyMobileNumber = companyMobileNumberError;
      }

      const companyAltMobileNumberError = validatePhoneNumber(
        values.companyAltMobileNumber
      );
      if (companyAltMobileNumberError) {
        errors.companyAltMobileNumber = companyAltMobileNumberError;
      }

      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const formData = new FormData();
        let companyLogo: string | undefined = initialData?.companyLogo;

        if (selectedImage) {
          setIsImageUploading(true);
          formData.append("companyLogo", selectedImage);
          companyLogo = (await uploadImage(selectedImage)) || "";
          setIsImageUploading(false);
        }

        const formDataUp = new FormData();
        let backgroundImg: string | undefined = initialData?.backgroundImg;

        if (selectedImageUp) {
          setIsImageUploadingUp(true);
          formDataUp.append("backgroundImg", selectedImageUp);
          backgroundImg = (await uploadImage(selectedImageUp)) || "";
          setIsImageUploadingUp(false);
        }

        const updatedData = {
          id: initialData?.id,
          companyName: toProperCase(values.companyName),
          companyProvince: toProperCase(values.companyProvince),
          companyCity: toProperCase(values.companyCity),
          companyPostalCode: toAllCaps(values.companyPostalCode),
          companyStreetNumber: values.companyStreetNumber,
          companyStreetName: toProperCase(values.companyStreetName),
          companyPaymentMethod: values.companyPaymentMethod,
          companyEmail: values.companyEmail,
          companyMobileNumber: values.companyMobileNumber.replace(/-/g, ""),
          companyAltMobileNumber: values.companyAltMobileNumber.replace(
            /-/g,
            ""
          ),
          companyWebSiteLink: values.companyWebSiteLink,
          companyDescription: values.companyDescription,
          companyLogo,
          logowidthPrint: values.logowidthPrint,
          backgroundImg,
          header_message: values.header_message,
          body_message_start: values.body_message_start,
          body_message_end: values.body_message_end,
          footer_message: values.footer_message,

        };

        const response = await settingData(updatedData).unwrap();
        if (!response.status) {
          showErrorMessage(response.message);
        } else {
          showMessage(response.message);
          const tokenData = response.data as ICompanyDetails;
          if (tokenData) {
            // localStorage.setItem("backgroundImg", tokenData.backgroundImg);
            // localStorage.setItem("companyLogo", tokenData.companyLogo);
            // window.location.reload();
          }
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.companyName === "" ||
      formik.values.companyName === undefined
      ? false
      : true;
  }, [formik]);

  const resizeImage = (
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions while maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
              });
              resolve(resizedFile);
            } else {
              reject(new Error("Canvas is empty"));
            }
          }, file.type);
        };

        img.onerror = (error) => reject(error);
      };
    });
  };

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 10 * 1024 * 1024;

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        setSelectedImage(undefined);
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 10 MB.");
        setSelectedImage(undefined);
      } else {
        try {
          const resizedImage = await resizeImage(file, 500, 500);
          setSelectedImage(resizedImage);
        } catch (error) {
          showErrorMessage("Failed to resize the image.");
          setSelectedImage(undefined);
        }
      }
    } else {
      setSelectedImage(undefined);
    }
  };

  const resizeImageUp = (
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions while maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile2 = new File([blob], file.name, {
                type: file.type,
              });
              resolve(resizedFile2);
            } else {
              reject(new Error("Canvas is empty"));
            }
          }, file.type);
        };

        img.onerror = (error) => reject(error);
      };
    });
  };

  const handleImageChange2 = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 10 * 1024 * 1024;

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        setSelectedImageUp(undefined);
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 10 MB.");
        setSelectedImageUp(undefined);
      } else {
        try {
          const resizeImageJJ = await resizeImageUp(file, 500, 500);
          setSelectedImageUp(resizeImageJJ);
        } catch (error) {
          showErrorMessage("Failed to resize the image.");
          setSelectedImageUp(undefined);
        }
      }
    } else {
      setSelectedImageUp(undefined);
    }
  };
  const resizeImagePunch = (
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions while maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile2 = new File([blob], file.name, {
                type: file.type,
              });
              resolve(resizedFile2);
            } else {
              reject(new Error("Canvas is empty"));
            }
          }, file.type);
        };

        img.onerror = (error) => reject(error);
      };
    });
  };

  const handleImageChangePunch = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 10 * 1024 * 1024;

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        setSelectedImagePunch(undefined);
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 10 MB.");
        setSelectedImagePunch(undefined);
      } else {
        try {
          const resizeImageJJ = await resizeImagePunch(file, 500, 500);
          setSelectedImagePunch(resizeImageJJ);
        } catch (error) {
          showErrorMessage("Failed to resize the image.");
          setSelectedImagePunch(undefined);
        }
      }
    } else {
      setSelectedImagePunch(undefined);
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Grid container spacing={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Client Report Setting
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={8} p={"24px"}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Header</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                      <ReactQuill
                            value={formik.values.header_message}
                            onChange={(value) =>
                              formik.setFieldValue("header_message", value)
                            }
                            placeholder="Type your message..."
                            theme="snow"
                            style={{ height: "200px", marginBottom: "20px" }} 
                            modules={{
                              toolbar: [
                                [{ font: [] }],
                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ color: [] }, { background: [] }],
                                [{ script: "sub" }, { script: "super" }],
                                [{ list: "ordered" }, { list: "bullet" }],
                                [{ indent: "-1" }, { indent: "+1" }],
                                [{ direction: "rtl" }],
                                [{ align: [] }],
                                ["blockquote", "code-block"],
                                ["link", "image", "video"],
                                ["clean"],
                              ],
                            }}
                          />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Body Start Message</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                      <ReactQuill
                            value={formik.values.body_message_start}
                            onChange={(value) =>
                              formik.setFieldValue("body_message_start", value)
                            }
                            placeholder="Type your message..."
                            theme="snow"
                            style={{ height: "200px", marginBottom: "20px" }} 
                            modules={{
                              toolbar: [
                                [{ font: [] }],
                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ color: [] }, { background: [] }],
                                [{ script: "sub" }, { script: "super" }],
                                [{ list: "ordered" }, { list: "bullet" }],
                                [{ indent: "-1" }, { indent: "+1" }],
                                [{ direction: "rtl" }],
                                [{ align: [] }],
                                ["blockquote", "code-block"],
                                ["link", "image", "video"],
                                ["clean"],
                              ],
                            }}
                          />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Body End Message</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                      <ReactQuill
                            value={formik.values.body_message_end}
                            onChange={(value) =>
                              formik.setFieldValue("body_message_end", value)
                            }
                            placeholder="Type your message..."
                            theme="snow"
                            style={{ height: "200px", marginBottom: "20px" }} 
                            modules={{
                              toolbar: [
                                [{ font: [] }],
                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ color: [] }, { background: [] }],
                                [{ script: "sub" }, { script: "super" }],
                                [{ list: "ordered" }, { list: "bullet" }],
                                [{ indent: "-1" }, { indent: "+1" }],
                                [{ direction: "rtl" }],
                                [{ align: [] }],
                                ["blockquote", "code-block"],
                                ["link", "image", "video"],
                                ["clean"],
                              ],
                            }}
                          />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container alignItems="center">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="subtitle1">Footer Message</Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                      <ReactQuill
                            value={formik.values.footer_message}
                            onChange={(value) =>
                              formik.setFieldValue("footer_message", value)
                            }
                            placeholder="Type your message..."
                            theme="snow"
                            style={{ height: "300px", marginBottom: "20px" }} 
                            modules={{
                              toolbar: [
                                [{ font: [] }],
                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ color: [] }, { background: [] }],
                                [{ script: "sub" }, { script: "super" }],
                                [{ list: "ordered" }, { list: "bullet" }],
                                [{ indent: "-1" }, { indent: "+1" }],
                                [{ direction: "rtl" }],
                                [{ align: [] }],
                                ["blockquote", "code-block"],
                                ["link", "image", "video"],
                                ["clean"],
                              ],
                            }}
                          />
                      </Grid>
                    </Grid>
                  </Grid>
                 
                </Grid>
              </Card>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container spacing={3} p={"24px"}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="contained"
                      startIcon={
                        settingLoading ? (
                          <CircularProgress
                            size={18}
                            className={classes.isLoading}
                          />
                        ) : (
                          <CheckCircleOutlineIcon />
                        )
                      }
                      className={classes.addButton}
                      onClick={() => formik.handleSubmit()}
                      disabled={!formValid}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default Index;
